import { Injectable, Output, EventEmitter, OnInit } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { BehaviorSubject, Subject } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class SharedDataService {
  public _comp1ValueBS: Subject<any> = new Subject();
  public isSidebarLoaded: boolean = false;
  public sideMenusList: any[] = [];
  public sidebarURLs: any[] = [];
  public setNavigateURL: any = null;
  private helper: JwtHelperService;
  public updateComp1Val(val) {
    this._comp1ValueBS.next(val);
  }

  decodeToken() {
    this.helper = new JwtHelperService();
    let token = this.helper.decodeToken(localStorage.getItem(environment.ProjectName + "-token"));
    // let token = this.helper.decodeToken(localStorage.getItem("token"));
    return token;
  }
  TimeConvert(type: any, data: any = null) {
    if (type == "Last_6_Month") {
      var start = new Date(new Date().setDate(new Date().getDate() - 180));
      start.setHours(0, 0, 0, 0);
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      return { startTime: start.toISOString(), endtime: end.toISOString() };
    }
    else if (type == "1_Day") {
      var start = new Date(new Date().setDate(new Date().getDate() - 1));
      start.setHours(0, 0, 0, 0);
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      return { startTime: start.toISOString(), endtime: end.toISOString() };
    }
    else if (type == "30_Day") {
      var start = new Date(new Date().setDate(new Date().getDate() - 30));
      start.setHours(0, 0, 0, 0);
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      // return { startTime: start.toISOString(), endtime: end.toISOString() };
      return { startTime: start.toISOString().slice(0, 10) + "T00:00:01.000", endtime: end.toISOString().slice(0, 10) + "T23:59:59.999" };

    }
    else if (type == "7_Day") {
      var start = new Date(new Date().setDate(new Date().getDate() - 7));
      start.setHours(0, 0, 0, 0);
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      return { startTime: start.toISOString(), endtime: end.toISOString() };
    }
    else if (type == "Yearly") {
      var start = new Date(new Date().setDate(new Date().getDate() - 365));
      start.setHours(0, 0, 0, 0);
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      return { startTime: start.toISOString(), endtime: end.toISOString() };
    } else if (type == 'Custom') {
      start = new Date(data.fromDate);
      end = new Date(data.toDate);
      // return { startTime: start.toISOString().slice(0, 10) + "T00:00:01.000+05:00", endtime: end.toISOString().slice(0, 10) + "T23:59:59.999+05:00" };
      return { startTime: start.toISOString().slice(0, 10) + "T00:00:01.000", endtime: end.toISOString().slice(0, 10) + "T23:59:59.999" };

    }
  }
}
